/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Controls/Heart': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M24.426 14.334c-.306 1.763-1.714 5.927-8.426 8.154-6.712-2.227-8.12-6.39-8.426-8.154-.078-.48-.074-.775-.074-.8 0-2.142 1.536-3.868 3.573-4.018a3.21 3.21 0 01.239-.009c1.01 0 2.083.677 2.732 1.533.65.856.82 1.147 1.219 1.856.162.286.45.43.737.43a.843.843 0 00.737-.43c.399-.71.57-1 1.219-1.856.65-.856 1.72-1.533 2.733-1.533.078 0 .158.003.238.01 2.037.149 3.573 1.875 3.573 4.016 0 .026.004.321-.074.801m2.073-.829c0-3.176-2.332-5.763-5.427-5.99a4.905 4.905 0 00-.383-.015c-1.284 0-3.113.5-4.69 2.81C14.425 8 12.597 7.5 11.313 7.5c-.127 0-.255.005-.385.015-3.094.227-5.427 2.814-5.426 5.99-.002.047-.01.48.115 1.249.356 2.048 2.023 7.089 9.796 9.653.188.062.386.093.588.093.202 0 .4-.031.588-.093 7.773-2.564 9.44-7.605 9.796-9.653.125-.768.117-1.202.115-1.249"/>'
  }
})
